import { getStatusBadgeColorByBase } from '@/styles/projectColorTokens';

export type HistoryChangeTone = 'add' | 'remove' | 'change';

export function isEmptyHistoryValue(value: string): boolean {
  const t = value.trim().toLowerCase();
  return t === '' || t === 'пусто';
}

/** Зелёный — добавление, красный — удаление, синий — изменение */
export function historyChangeTone(before: string, after: string): HistoryChangeTone {
  const bEmpty = isEmptyHistoryValue(before);
  const aEmpty = isEmptyHistoryValue(after);
  if (bEmpty && !aEmpty) return 'add';
  if (!bEmpty && aEmpty) return 'remove';
  return 'change';
}

export const HISTORY_CHANGE_TONE_STYLES: Record<
  HistoryChangeTone,
  { bg: string; color: string }
> = {
  add: getStatusBadgeColorByBase('Готов'),
  remove: {
    bg: 'color-mix(in srgb, var(--accent-error) 16%, transparent)',
    color: 'var(--accent-error)',
  },
  change: {
    bg: 'color-mix(in srgb, var(--accent-warning) 15%, transparent)',
    color: 'var(--accent-warning)',
  },
};
